import { render } from "./ViewDescargasRecebida.vue?vue&type=template&id=6611ca8a&scoped=true"
import script from "./ViewDescargasRecebida.vue?vue&type=script&lang=js"
export * from "./ViewDescargasRecebida.vue?vue&type=script&lang=js"

import "./ViewDescargasRecebida.vue?vue&type=style&index=0&id=6611ca8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6611ca8a"]])

export default __exports__